import type { FundingAppeal } from "@mixitone/models";
import { LoadingModal } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import Form from "components/Forms/Form";
import FormButtons from "components/Forms/FormButtons";
import { ModalFormFieldset } from "components/Forms/FormRenderers/ModalFormRenderer";
import AppModal from "components/common/AppModal";
import { injectModal } from "lib/injectParams";
import routeService from "services/RouteService";
import { useMemo } from "react";
import { FundingAppealFormController } from "components/Pages/Funding/FundingAppealFormController";

const NewAppealModalContent: React.FC<{ clubId: string }> = () => {
  const controller = FundingAppealFormController.use();
  const { saving, loading } = controller.state;
  const fields = useMemo(() => Object.values(controller.fields()), [controller]);

  if (loading) return <LoadingModal title="New appeal" />;

  return (
    <AppModal title="New appeal" className="max-h-[80vh]">
      <Form name="funding_appeal">
        <fieldset disabled={saving}>
          <ModalFormFieldset fields={fields} />
        </fieldset>
        <FormButtons showDelete={false} saveTitle="Create" />
      </Form>
    </AppModal>
  );
};

const NewAppealView = FundingAppealFormController.scope(ApplicationView(NewAppealModalContent));

export default injectModal((props: { clubId: string }) => (
  <NewAppealView
    {...props}
    onSubmit={async (record: FundingAppeal) => {
      routeService.closeModal();
      routeService.navigate(`/clubs/${props.clubId}/funding/appeals/${record.id}` as any);
    }}
  />
));
